/**
 * @generated SignedSource<<a1b6ca6f0ff66f02edd83cf034f38bcb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedItemDetails_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemDetailsAdditionalOptions_item" | "PdpRespSharedItemDetailsDescription_item" | "PdpRespSharedItemDetailsList_item">;
  readonly " $fragmentType": "PdpRespSharedItemDetails_item";
};
export type PdpRespSharedItemDetails_item$key = {
  readonly " $data"?: PdpRespSharedItemDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedItemDetails_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetailsList_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetailsDescription_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetailsAdditionalOptions_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "bd499b607da603635f08d782898955d3";

export default node;
